import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledCalendarEventDate,
  StyledDateDayMonth,
  StyledDayNumber,
  StyledMonth,
  StyledDayText,
  StyledDateRight,
  StyledDayNumberNoDesktop
} from './styleDate';
import {
  StyledCalendarEvent,
  StyledCalendarEventNot,
  StyledListEvent,
  StyledListEventName,
  StyledListEventItem,
  StyledListEventHours,
  StyledDragIcon
} from './style';

const CalendarEventDay = ({
  className,
  dataEvent,
  eventDay,
  dateDay,
  transform,
  transition,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onTransitionEnd,
  id
}) => (
  <StyledCalendarEvent
    transform={transform}
    transition={transition}
    className={className}
    eventDay={eventDay}
    onTouchStart={onTouchStart}
    onTouchMove={onTouchMove}
    onTouchEnd={onTouchEnd}
    onTransitionEnd={onTransitionEnd}
    id={id}
  >
    <StyledCalendarEventDate>
      <StyledDragIcon />
      <div>
        <StyledDateDayMonth date={dateDay}>
          <div>
            <StyledDayNumber date={dateDay} />
          </div>
          <StyledDateRight>
            <StyledMonth date={dateDay} />
            <StyledDayNumberNoDesktop date={dateDay} />
            <StyledDayText date={dateDay} />
          </StyledDateRight>
        </StyledDateDayMonth>
      </div>
    </StyledCalendarEventDate>
    {dataEvent ? (
      <StyledListEvent>
        {dataEvent.map(item => (
          <StyledListEventItem>
            <StyledListEventName> {item.eventName} </StyledListEventName>
            {item.eventHour && (
              <div>
                {item.eventHour.map(item => (
                  <StyledListEventHours>
                    {item.eventHourStart}
                  </StyledListEventHours>
                ))}
              </div>
            )}
          </StyledListEventItem>
        ))}
      </StyledListEvent>
    ) : (
      <StyledCalendarEventNot>
        Este día no has consumido ningún vale de comida.
      </StyledCalendarEventNot>
    )}
  </StyledCalendarEvent>
);

CalendarEventDay.propTypes = {
  className: PropTypes.string,
  eventDay: PropTypes.bool,
  dateDay: PropTypes.string,
  dataEvent: PropTypes.shape({
    eventName: PropTypes.string,
    eventHour: PropTypes.shape({
      eventHourStart: PropTypes.string,
      eventHourEnd: PropTypes.string
    })
  })
};

CalendarEventDay.defaultProps = {
  eventDay: true
};

export default CalendarEventDay;
